import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

const useRUMView = (name: string) => {
  useEffect(() => {
    datadogRum.startView({ name });
  }, [name]);
};

export default useRUMView;
